import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Text, TextType } from 'ui-components/components/text';

import { useModal } from '../../../../../hooks/use-modal';
import { WorkflowSteps } from '../../../../../tracking/use-workflow-tracking';
import { useImportContext } from '../import-context';
import { messages } from './messages';
import styles from './styles.module.css';
import { MappingManagementModal } from '../mapping-management-modal/mapping-management-modal';

/**
 * @param {object} props
 * @param {string} [props.menuClassName]
 * @returns {React.JSX.Element}
 */
export const MappingList = ({ menuClassName = '' }) => {
  const { initRequest, setMapping, mappingList, getMappingById, trackProcess } = useImportContext();

  const { open, close, isOpen } = useModal();

  const getTogglerValue = () => {
    const { uniqueId } = initRequest.mapping;

    if (!uniqueId) {
      return <FormattedMessage {...messages.selectOption} />;
    }

    return getMappingById(uniqueId)?.name;
  };

  const changeMappingTemplate = (mapping) => {
    trackProcess(WorkflowSteps.CSV_IMPORT_CHOOSE_MAPPING_TEMPLATE, { mapping });
    setMapping(mapping);
  };

  return (
    <>
      <Text
        className={styles['dropdown-title']}
        formattedMessageValues={{
          optionalMessage: (chunks) => <span className={styles['dropdown-optional-message']}>{chunks}</span>,
        }}
        textType={TextType.Label}
        value={messages.selectImportTemplate}
      />
      <DropdownMenu
        className={classnames(styles['dropdown-menu'], menuClassName)}
        dropdownMenuShouldHaveWidthOfButton
        fullWidth
        variant='form'
      >
        <DropdownMenuToggler className={styles['dropdown-menu-toggler']}>{getTogglerValue()}</DropdownMenuToggler>
        <DropdownMenuItem key='default-option' className={styles['default-dropdown-item']} onClick={() => changeMappingTemplate({})}>
          <FormattedMessage {...messages.selectOption} />
        </DropdownMenuItem>
        <DropdownMenuItem key='manage-templates-option' onClick={open}>
          <FormattedMessage {...messages.manageTemplatesOption} />
        </DropdownMenuItem>
        {mappingList.map((mapping) => {
          return (
            <DropdownMenuItem key={mapping.uniqueId} onClick={() => changeMappingTemplate(mapping)}>
              {mapping.name}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenu>
      <Text className={styles['dropdown-description']} textType={TextType.Description} value={messages.dropdownInfoMessage} />
      <MappingManagementModal onClose={close} show={isOpen} />
    </>
  );
};
